export const getVersionMessage = (version) => {
	if (version.current_version === '0.0.0') {
		return 'Version not checked';
	}

	if (!version.checked) {
		return 'Checking version ...';
	}

	if (!version.accepted) {
		return `This application must be updated! (v${version.current_version} -> v${version.latest_version})`;
	}

	if (!version.latest) {
		return `This application is not the latest version! (v${version.current_version} -> v${version.latest_version})`;
	}

	return '';
};
